import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject, forkJoin, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';
import * as _ from 'lodash';
import { Title } from '@angular/platform-browser';
import { AsyncLocalStorageService, LoggerService, AsyncSessionStorageService } from '@kpmg-tax/core';
//import {
  //Client,
  //Project,
  // FavoriteProject,
  // RecentProject,
  // InlineAttribute,
  // SavedExcerpts,
  // Item2,
  // Role
//} from '../../models';
//import {FavoriteProject} from '../../models/favourite-project';
// import { RecentProject } from '../../models/recent-project';

// import { FavoriteProject, RecentProject, ModuleRoleSet } from '../shared';

// import { EnvSettingsService } from '../env-settings';
// import { PreferencesService } from '../preferences';
// import { TeamSecurityService } from '../team-security';
import { AppContextState } from './app-context.state';
// import { ClientService } from '../client';
// import { ProjectService } from '../project';
import { HttpClient } from '@angular/common/http';
// import { AuthPolicyService } from 'src/app/auth';
import { User } from 'src/app/core/auth/user.model';
// import { SessionStorageService } from 'angular-web-storage';
// import { ActivityMonitorConfig } from '../../activity-monitor';


// Local Storage Keys
export const STORAGEKEY_IMPERSONATE = 'Impersonate';
export const STORAGEKEY_FAVORITE_PROJECTS = 'favoriteProjects';
export const STORAGEKEY_RECENT_PROJECTS = 'recentProjects';
export const STORAGEKEY_HOME_OPEN = 'homeOpen';
export const STORAGEKEY_HELP_OPEN = 'helpOpen';
export const STORAGEKEY_THEME = 'theme';
export const STORAGEKEY_LAST_PENDING_LOGOUT = 'lastPendingLogout';
export const STORAGEKEY_LAST_CONFIRMED_LOGOUT = 'lastConfirmedLogout';
export const STORAGEKEY_LAST_CANCELLED_LOGOUT = 'lastCancelledLogout';
export const STORAGEKEY_LAST_SESSION_ACTIVITY = 'lastSessionActivity';
export const STORAGEKEY_LAST_SESSION_HEARTBEAT = 'lastSessionHeartbeat';
export const STORAGEKEY_LAST_SESSION_WARNING = 'lastSessionWarning';
export const STORAGEKEY_LAST_SESSION_EXTENSION = 'lastSessionExtension';
export const STORAGEKEY_INLINEATTRIBUTE = 'inlineattributes';
export const STORAGEKEY_SYSTEMEXCERPTS = 'systemexcerpts';
export const STORAGEKEY_USEREXCERPTS = 'userexcerpts';
export const STORAGEKEY_ACTIVITY_MONITOR_CONFIG_OVERRIDE = 'ActivityMonitorConfigOverride';

@Injectable({
  providedIn: 'root'
})
export class AppContextStore {
  private _appContextState: AppContextState;
  private _coreAPIRoute = 'api/v1/Core';
  private _excerptAPIRoute = 'api/v1/SavedExcerpt';

  // Observable sources
  private _userSource: BehaviorSubject<User>;
  private _appModuleCodesSource: BehaviorSubject<string[]>;
  // private _favoriteProjectsSource: BehaviorSubject<FavoriteProject[]>;
  // private _recentProjectsSource: BehaviorSubject<RecentProject[]>;
  //private _clientSource: BehaviorSubject<Client>;
  //private _projectSource: BehaviorSubject<Project>;
  // private _userRolesSource: BehaviorSubject<Role[]>;


  // Observable streams
  user$: Observable<User>;
  // favoriteProjects$: Observable<FavoriteProject[]>;
  // recentProjects$: Observable<RecentProject[]>;
  //client$: Observable<Client>;
  //project$: Observable<Project>;
  // userRoles$: Observable<Role[]>;


  constructor(
    private _asyncStorage: AsyncLocalStorageService,
    // private _preferencesService: PreferencesService,
    private _loggerService: LoggerService,
    // private _envSettings: EnvSettingsService,
    // private _clientService: ClientService,
    // private _projectService: ProjectService,
    // private _authService: AuthPolicyService,
    private _titleService: Title,
    private _asyncsessionStorage: AsyncSessionStorageService,
    private _http: HttpClient
  ) {
    this._appContextState = {
      user: null,
      // favoriteProjects: [],
      // recentProjects: [],
      isHomeOpen: false,
      isHelpOpen: false,
      // client: null,
      // project: null,
      // userRoles: null,
    };

    // this._userSource = new BehaviorSubject<User>(this._appContextState.user);
    // this._favoriteProjectsSource = new BehaviorSubject<FavoriteProject[]>(this._appContextState.favoriteProjects);
    // this._recentProjectsSource = new BehaviorSubject<RecentProject[]>(this._appContextState.recentProjects);
    // this._clientSource = new BehaviorSubject<Client>(this._appContextState.client);
    // this._projectSource = new BehaviorSubject<Project>(this._appContextState.project);
    // this._userRolesSource = new BehaviorSubject<Role[]>(this._appContextState.userRoles);


    // this.user$ = this._userSource.asObservable();
    // this.favoriteProjects$ = this._favoriteProjectsSource.asObservable();
    // this.recentProjects$ = this._recentProjectsSource.asObservable();
    // this.client$ = this._clientSource.asObservable();
    // this.project$ = this._projectSource.asObservable();
    // this.userRoles$ = this._userRolesSource.asObservable();
  }
  /*
  getCurrentClientContext(): string {
    return this._clientSource.value && this._clientSource.value.id || '';
  }

  getCurrentProjectContext(): string {
    return this._projectSource.value && this._projectSource.value.id || '';
  }
  */
  initialize(): void {

    this._loggerService.info(`App Context Store - Initializing`);
    this.initUserInfo();
    // this.initCreateProjectInfo();
    // this.initTeamSecurityInfo();

  }

  private initUserInfo(): void {

    forkJoin(
      // this._authService.getCurrentUser(),
      // this._preferencesService.getFavoriteProjects(),
      // this._preferencesService.getRecentProjects(),
      // this._authService.getCurrentUserRoles()
    ).subscribe(

      responses => {

        // this._appContextState.user = responses[0];
        // this._appContextState.favoriteProjects = responses[1];
        // this._appContextState.recentProjects = responses[2];
        // this._appContextState.userRoles = responses[3].role;
        this._loggerService.info('App Context Store - user info & preferences initialized: ' + new Date().toLocaleTimeString());

        // Store favorites and recents in localStorage for cross-tab/window updates
        // this._asyncStorage.setItem(STORAGEKEY_FAVORITE_PROJECTS, JSON.stringify(this._appContextState.favoriteProjects));
        // this._asyncStorage.setItem(STORAGEKEY_RECENT_PROJECTS, JSON.stringify(this._appContextState.recentProjects));

        // Check for the homepage open flag
        this._asyncStorage.getItemAsync(STORAGEKEY_HOME_OPEN).subscribe(isHomeOpen => {
          if (isHomeOpen) {
            this._appContextState.isHomeOpen = isHomeOpen === 'true';
          }
          this._asyncStorage.setItem(STORAGEKEY_HOME_OPEN, isHomeOpen);
        });

        // Check for the help page open flag
        this._asyncStorage.getItemAsync(STORAGEKEY_HELP_OPEN).subscribe(isHelpOpen => {
          if (isHelpOpen) {
            this._appContextState.isHelpOpen = isHelpOpen === 'true';
          }
          this._asyncStorage.setItem(STORAGEKEY_HELP_OPEN, isHelpOpen);
        });
        // Check for the Inline Attributes
        // this._asyncsessionStorage.getItemAsync(STORAGEKEY_INLINEATTRIBUTE).subscribe(inlineAttribues => {

        //   if (inlineAttribues == null) {
        //     this.getinlineattributeList().subscribe(
        //       (result: any) => {
        //         result = result.sort((a, b) => a.sortorder - b.sortorder);
        //         this._asyncsessionStorage.setItem(STORAGEKEY_INLINEATTRIBUTE, JSON.stringify(result));
        //       });
        //   }

        // });

        // Check for the Saved Excerpts
        // this._asyncsessionStorage.getItemAsync(STORAGEKEY_SYSTEMEXCERPTS).subscribe(inlineAttribues => {

        //   if (inlineAttribues == null) {
        //     this.getSystemExcerptsList().subscribe(
        //       (result: any) => {

        //         this._asyncsessionStorage.setItem(STORAGEKEY_SYSTEMEXCERPTS, JSON.stringify(result));
        //       });
        //   }

        // });

        // Notify subscribers
        this._userSource.next(this._appContextState.user);
        // this._favoriteProjectsSource.next(this._appContextState.favoriteProjects);
        // this._recentProjectsSource.next(this._appContextState.recentProjects);
        // this._userRolesSource.next(this._appContextState.userRoles);
      },
      error => {
        this._loggerService.error('App Context Store - Unable to initialize user info & preferences.');
        this._loggerService.error(error);
      }

    );
  }

  // getinlineattributeList(): Observable<Array<InlineAttribute>> {
  //   return this._http.get<Array<InlineAttribute>>(this._envSettings.service.knowledgebaseService + this._coreAPIRoute + `/getlistinlineattributesbyflag?category=1`); //category = 1 for Knowledgebase
  // }

  // getSystemExcerptsList(): Observable<Array<SavedExcerpts>> {
  //   return this._http.get<Array<SavedExcerpts>>(this._envSettings.service.knowledgebaseService + this._coreAPIRoute + `/getlistsavedexcerpt`);
  // }
  // getUserExcerptsList(clientId: string, projectId: string): Observable<Array<SavedExcerpts>> {
  //   return this._http.get<Array<SavedExcerpts>>(this._envSettings.service.knowledgebaseService + this._excerptAPIRoute + `/list?clientId=${clientId}&projectId=${projectId}`);
  // }
  // refreshUserExcerpts(clientId: string, projectId: string) {
  //   if (clientId && clientId.length > 0 && projectId && projectId.length > 0) {
  //     // Check for the User Saved Excerpts

  //     this.getUserExcerptsList(clientId, projectId).subscribe(
  //       (result: any) => {

  //         this._asyncsessionStorage.setItem(STORAGEKEY_USEREXCERPTS, JSON.stringify(result));
  //       });

  //   }

  // }
  // initClientProject(clientId: string, projectId: string): void {


  //   if (clientId && clientId.length > 0 && projectId && projectId.length > 0 && !this._appContextState.project) {
  //     this._loggerService.info(`App Context Store - Initializing ClientId: ${clientId} and ProjectId ${projectId} ... ${new Date().toLocaleTimeString()}`);
  //     forkJoin(
  //       this._clientService.getClient(clientId),
  //       this._projectService.getProjectDetail(clientId, projectId)
  //     ).subscribe(
  //       responses => {
  //         this.setClient(<Client>responses[0]);
  //         this.setProject(<Project>responses[1]);

  //         this._loggerService.info('App Context Store - Client and project initialized: ' + new Date().toLocaleTimeString());

  //         this._clientSource.next(this._appContextState.client);
  //         this._projectSource.next(this._appContextState.project);
  //       },
  //       error => {
  //         this._loggerService.error('App Context Store - Unable to initialize client and project.');
  //         this._loggerService.error(error);
  //       }
  //     );
  //   } else if (clientId && clientId.length > 0 && !this._appContextState.client) {
  //     // We only update the references if the client state has never been set. Future updates to 
  //     // the client state will be driven by other portions of the application
  //     this._loggerService.info(`App Context Store - Initializing ClientId: ${clientId} ONLY ... ${new Date().toLocaleTimeString()}`);
  //     this._clientService.getClient(clientId).subscribe(
  //       client => {
  //         this._loggerService.info('App Context Store - client initialized: ' + new Date().toLocaleTimeString());
  //         this._appContextState.client = client;
  //         this._clientSource.next(this._appContextState.client);
  //       },
  //       error => {
  //         this._loggerService.error('App Context Store - Unable to initialize client.');
  //         this._loggerService.error(error);
  //       }
  //     );
  //   }
  // }


  // private initTeamSecurityInfo(): void {
  //   this._teamSecurityService.getAllRoles().subscribe(
  //     moduleRoleSets => {
  //       this._loggerService.info('App Context Store - team-security info initialized: ' + new Date().toLocaleTimeString());
  //       this._appContextState.moduleRoleSets = moduleRoleSets;
  //       this._moduleRoleSetSource.next(this._appContextState.moduleRoleSets);
  //     },
  //     error => {
  //       this._loggerService.error('App Context Store - Unable to initialize team-security info.');
  //       this._loggerService.error(error);
  //     }
  //   );
  // }

  // setProjectContext(clientId: string, projectId: string): void {
  //   if (clientId && clientId.length > 0 && projectId && projectId.length > 0) {
  //     this._loggerService.info(`App Context Store - Setting ProjectId ${projectId} ... ${new Date().toLocaleTimeString()}`);

  //     this._projectService.getProjectDetail(clientId, projectId).subscribe(
  //       responses => {
  //         this.setProject(<Project>responses);
  //         this._loggerService.info('App Context Store - project context updated: ' + new Date().toLocaleTimeString());
  //       },
  //       error => {
  //         this._loggerService.error('App Context Store - Unable to update project context.');
  //         this._loggerService.error(error);
  //       }
  //     );
  //   }
  // }

  // setClientProjectContext(clientId: string, projectId: string): Observable<boolean> {
  //   if (clientId && clientId.length > 0 && projectId && projectId.length > 0) {
  //     this._loggerService.info(`App Context Store - Initializing ClientId: ${clientId} and ProjectId ${projectId} ... ${new Date().toLocaleTimeString()}`);
  //     return forkJoin(
  //       this._clientService.getClient(clientId),
  //       this._projectService.getProjectDetail(clientId, projectId)
  //     ).pipe(
  //       switchMap(responses => {
  //         this.setClient(<Client>responses[0]);
  //         this.setProject(<Project>responses[1]);
  //         this._loggerService.info('App Context Store - Client and project updated: ' + new Date().toLocaleTimeString());
  //         return of(true);
  //       }),
  //       catchError(error => {
  //         this._loggerService.error('App Context Store - Unable to initialize client and project.');
  //         this._loggerService.error(error);
  //         return of(false);
  //       })
  //     );
  //   } else {
  //     return of(false);
  //   }
  // }

  // addFavoriteProject(clientId: string, projectId: string): void {
  //   this._preferencesService.addFavoriteProject(clientId, projectId).subscribe(
  //     favoriteEng => {
  //       let favProjects = this._appContextState.favoriteProjects;
  //       favProjects.splice(0, 0, favoriteEng);
  //       // Update app context and broadcast change
  //       this._appContextState.favoriteProjects = favProjects;
  //       this._asyncStorage.setItem(STORAGEKEY_FAVORITE_PROJECTS, JSON.stringify(this._appContextState.favoriteProjects));
  //       this._favoriteProjectsSource.next(this._appContextState.favoriteProjects);
  //     },
  //     error => {
  //       this._loggerService.error('App Context Store - Unable to add favorite project.');
  //       this._loggerService.error(error);
  //     }
  //   );
  // }

  // removeFavoriteProject(clientId: string, projectId: string): void {
  //   this._preferencesService.removeFavoriteProject(clientId, projectId).subscribe(
  //     (noValue: any) => {
  //       let favProjects = this._appContextState.favoriteProjects;
  //       let remaining = favProjects.filter(fe => fe.projectid !== projectId);
  //       // Update app context and broadcast change
  //       this._appContextState.favoriteProjects = remaining;
  //       this._asyncStorage.setItem(STORAGEKEY_FAVORITE_PROJECTS, JSON.stringify(this._appContextState.favoriteProjects));
  //       this._favoriteProjectsSource.next(this._appContextState.favoriteProjects);
  //     },
  //     error => {
  //       this._loggerService.error('App Context Store - Unable to remove favorite project.');
  //       this._loggerService.error(error);
  //     }
  //   );
  // }

  // updateLastAccessedFavorite(favProjectId: string): void {
  //   const favProject = this._appContextState.favoriteProjects.filter(fe => fe.projectid === favProjectId)[0];

  //   // Execute service calls in parallel and join to all observable results
  //   forkJoin(
  //     this._preferencesService.addRecentProject(favProject.clientid, favProject.projectid),
  //     this._preferencesService.updateLastAccessedFavorite(favProjectId)
  //   ).subscribe(
  //     responses => {
  //       //this._appContextState.recentProjects = responses[0];
  //       //this._asyncStorage.setItem(STORAGEKEY_RECENT_PROJECTS, JSON.stringify(this._appContextState.recentProjects));
  //       //this._recentProjectsSource.next(this._appContextState.recentProjects);

  //       // Move the favorite engagement to the front of the list
  //       let remaining = this._appContextState.favoriteProjects.filter(fe => fe.projectid !== favProjectId);
  //       remaining.splice(0, 0, favProject);
  //       // Update app context and broadcast change
  //       this._appContextState.favoriteProjects = remaining;
  //       this._asyncStorage.setItem(STORAGEKEY_FAVORITE_PROJECTS, JSON.stringify(this._appContextState.favoriteProjects));
  //       this._favoriteProjectsSource.next(this._appContextState.favoriteProjects);
  //     },
  //     error => {
  //       this._loggerService.error('App Context Store - Unable to update last accessed favorite.');
  //       this._loggerService.error(error);
  //     }
  //   );
  // }

  // addRecentProject(clientId: string, projectId: string, isNewProject: boolean = false): void {
  //   const retries = isNewProject ? 20 : 0;

  //   this._preferencesService.addRecentProject(clientId, projectId)
  //     .subscribe(
  //       recentProjs => {
  //         // Update app context and broadcast change
  //         let recentProjects = this._appContextState.recentProjects.filter(fe => fe.projectid !== projectId);
  //         recentProjects.splice(0, 0, recentProjs);

  //         this._appContextState.recentProjects = recentProjects;
  //         this._asyncStorage.setItem(STORAGEKEY_RECENT_PROJECTS, JSON.stringify(this._appContextState.recentProjects));
  //         this._recentProjectsSource.next(this._appContextState.recentProjects);
  //       },
  //       error => {
  //         this._loggerService.error('App Context Store - Unable to add recent project.');
  //         this._loggerService.error(error);
  //       }
  //     );
  // }

  // setClient(client: Client): void {
  //   this._appContextState.client = client;
  //   if (client) {
  //     this._titleService.setTitle(`${client.name}`);

  //   }
  //   this._clientSource.next(this._appContextState.client);
  // }

  // setProject(project: Project): void {
  //   this._appContextState.project = project;
  //   if (project) {
  //     this._titleService.setTitle(`${this._appContextState.client.name} - ${project.name}`);
  //   }
  //   this._projectSource.next(this._appContextState.project);
  // }

  getIsHomeOpen(): boolean {
    return this._appContextState.isHomeOpen;
  }

  setIsHomeOpen(isOpen: boolean): void {
    this._appContextState.isHomeOpen = isOpen;
    this._asyncStorage.setItem(STORAGEKEY_HOME_OPEN, String(this._appContextState.isHomeOpen));
  }

  getIsHelpOpen(): boolean {
    return this._appContextState.isHelpOpen;
  }

  setIsHelpOpen(isOpen: boolean): void {
    this._appContextState.isHelpOpen = isOpen;
    this._asyncStorage.setItem(STORAGEKEY_HELP_OPEN, String(this._appContextState.isHelpOpen));
  }

  sessionActivity(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_SESSION_ACTIVITY, Date.now().toString());
  }

  sessionHeartbeat(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_SESSION_HEARTBEAT, Date.now().toString());
  }

  sessionWarning(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_SESSION_WARNING, Date.now().toString());
  }

  sessionExtended(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_SESSION_EXTENSION, Date.now().toString());
  }

  pendingLogout(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_PENDING_LOGOUT, Date.now().toString());
  }

  confirmLogout(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_CONFIRMED_LOGOUT, Date.now().toString());
  }

  cancelLogout(): void {
    this._asyncStorage.setItem(STORAGEKEY_LAST_CANCELLED_LOGOUT, Date.now().toString());
  }

  // onFavoriteProjectsLocalStorageUpdated(favoriteProjs: FavoriteProject[]): void {
  //   this._appContextState.favoriteProjects = favoriteProjs;
  //   this._favoriteProjectsSource.next(this._appContextState.favoriteProjects);
  // }
  // activityConfigChanged(config: ActivityMonitorConfig): void {
  //   this._asyncStorage.setItem(STORAGEKEY_ACTIVITY_MONITOR_CONFIG_OVERRIDE, JSON.stringify(config));
  // }
  // onRecentProjectsLocalStorageUpdated(recentProjs: RecentProject[]): void {
  //   this._appContextState.recentProjects = recentProjs;
  //   this._recentProjectsSource.next(this._appContextState.recentProjects);
  // }
}
